export const RESTRICTION = 'restriction';
